import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/search.svg'


const _hoisted_1 = { class: "v-exam-laboratory" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "exam-laboratory-header exam-step-flow disabled" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "exam-laboratory-title" }, "Selecione os exames que você deseja agendar"),
  /*#__PURE__*/_createElementVNode("p", { class: "exam-step-flow-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-up" })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Buscar"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Nenhum exame laboratorial encontrado ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_7 = { class: "exam-laboratory-schedules" }

import { computed, reactive, ref, watch } from "vue";
import { useHead } from "@vueuse/head";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import { ObSpinner, ObInputSearch, ObTable } from "@/libs/components";

import CExamSchedule from "@/views/exam/schedule.vue";

import { addMoneyMask, removeMoneyMask } from "@/libs/utils";
import { scrollIntoView } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

useHead({ title: "Exames laboratoriais | obmed" });

const store = useStore();
const route = useRoute();
const router = useRouter();

store.commit("resetExamForm");

const form = computed(() => store.state.exam.form);
const examTableColumns = [
  { text: "Nome do exame", field: "nm_procedimento" },
  { text: "Local", field: "nm_estabelecimento", imageField: "aq_foto", descriptionField: "address" },
  { text: "Preço", field: "nr_valor" },
];

const laboratoryExamRows = computed(() =>
  store.state.exam.laboratory.list?.map((item) => ({
    ...item,
    nr_valor: addMoneyMask(item.nr_valor),
    address: `${item.nm_rua} ${item.nr_estabelecimento} ${item.nm_bairro} ${item.nm_cidade || ""} - ${
      item.ds_uf || ""
    }`,
  }))
);
const selectedProceduresId = ref<{ [procedureId: number]: boolean }>({});
const search = ref(route.query.q?.toString() || "");
const loading = reactive({ list: false });
const laboratoryPagination = computed(() => store.state.exam.laboratory.pagination);

function handleSelectLaboratoryExam(item: any) {
  const examId = Number(item.id);
  if (selectedProceduresId.value[examId]) selectedProceduresId.value[examId] = false;
  else selectedProceduresId.value[examId] = true;

  const cd_estabelecimento = item.cd_estabelecimento_id;
  store.commit("setExamForm", { cd_estabelecimento, key: "cd_procedimento", value: item.id, procedure: item });
  store.commit("setExamForm", { cd_estabelecimento, key: "cd_estabelecimento", value: cd_estabelecimento });
  store.commit("setExamForm", { cd_estabelecimento, key: "nm_estabelecimento", value: item.nm_estabelecimento });
  store.commit("setExamForm", {
    cd_estabelecimento,
    key: "nr_valor",
    value: removeMoneyMask(item.nr_valor).replace(/[^\d.-]/g, ""),
  });
}

async function searchLaboratoryExam() {
  store.commit("setLaboratoryExamPaginationPage", { page: Number(route.query.page?.toString()) || 1 });

  loading.list = true;
  await store.dispatch("searchLaboratoryExam", {
    search: search.value,
    cd_estabelecimento: route.query.o ? route.query.et?.toString() : undefined,
    isPaginated: true,
  });
  loading.list = false;

  scrollIntoView(".exam-laboratory-header");
}

watch([() => route.query.page], () => {
  searchLaboratoryExam();
});

watch([search], async () => {
  if (!search.value || search.value.length > 2) {
    await router.replace({ query: { ...route.query, page: 1 } });
    searchLaboratoryExam();
  }
});

searchLaboratoryExam();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(ObInputSearch), {
      modelValue: search.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
      modelModifiers: { trim: true },
      class: "has-icons-left",
      "element-id": "exame-search",
      width: "350px",
      placeholder: "Pesquisar pelo nome do exame",
      "is-disabled": _unref(loading).list
    }, {
      "search-icon": _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["modelValue", "is-disabled"]),
    _createVNode(_unref(ObTable), {
      class: "is-hoverable",
      columns: examTableColumns,
      "total-items": _unref(laboratoryPagination).items,
      "items-per-page": 12,
      rows: _unref(laboratoryExamRows),
      "selected-ids": selectedProceduresId.value,
      "page-number": _unref(laboratoryPagination).page,
      "element-id": "id_estabelecimento",
      "onClick:row": handleSelectLaboratoryExam,
      "onChange:checkbox": handleSelectLaboratoryExam
    }, {
      empty: _withCtx(() => [
        _hoisted_4,
        (search.value.length > 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "com o nome \"" + _toDisplayString(search.value) + "\"", 1))
          : _createCommentVNode("", true),
        _hoisted_6
      ]),
      _: 1
    }, 8, ["total-items", "rows", "selected-ids", "page-number"]),
    (_unref(loading).list && !_unref(laboratoryExamRows)?.length)
      ? (_openBlock(), _createBlock(_unref(ObSpinner), {
          key: 0,
          style: {"margin-top":"8rem"}
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form), (formItem, cd_estabelecimento) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (formItem.cd_procedimento.length)
            ? (_openBlock(), _createBlock(CExamSchedule, {
                key: 0,
                cd_estabelecimento: Number(cd_estabelecimento),
                flow: "laboratory"
              }, null, 8, ["cd_estabelecimento"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ])
  ]))
}
}

})